var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconTopBottom = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 45 35",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Set a Condition icon")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Query-Filtering",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Notes",
  transform: "translate(-537.000000, -451.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Top/Bottom-default",
  transform: "translate(515.000000, 450.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Set-a-Condition-icon",
  transform: "translate(20.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(2.882353, 1.440000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D1D3D4",
  x: 0,
  y: 18.72,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  fill: "#81848F"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 28.08,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#D1D3D4",
  x: 0,
  y: 9.36,
  width: 43.2352941,
  height: 5.76,
  rx: 2.88
}))))))));
export default SvgIconTopBottom;